<template>
  <div class="main">
    <div class="table-title-row-left">
      <h3 class="table-title-left">留言信息表</h3>
    </div>
    <div class="header-actions-horizontal">
<!--      <router-link to="/app/message-form" class="action-btn primary">✏️ 在线留言填写</router-link>-->
      <div style="flex: 1;"></div>
      
      <el-select
        v-model="dateQuick"
        placeholder="快捷日期"
        style="width: 150px; margin-right: 16px;"
        @change="handleQuickDate"
      >
        <el-option label="今天" value="today" />
        <el-option label="昨天" value="yesterday" />
        <el-option label="近7天" value="last7days" />
        <el-option label="自定义" value="custom" />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期时间"
        end-placeholder="结束日期时间"
        style="width: 340px; margin-right: 16px;"
        value-format="yyyy-MM-dd HH:mm:ss"
        format="yyyy-MM-dd HH:mm:ss"
        @change="onDateChange"
      />
      <el-input
        v-model="selectedPhone"
        placeholder="请输入电话"
        style="width: 220px; margin-right: 16px;"
        @input="onFilterChange"
      />
      <el-button type="primary" icon="el-icon-search" @click="onFilterChange">搜索</el-button>
      <!--<el-button type="success" icon="el-icon-download" :loading="exportLoading" @click="doExport">导出</el-button>-->
    </div>
    <div class="table-wrapper">
      <table class="info-table">
        <thead>
          <tr>
            <th>序号</th>
            <th>项目</th>
            <th>称呼</th>
            <th>电话/微信</th>
            <th>省/市</th>
            <th v-if="showMediaColumn">媒体</th>
            <th>留言时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="item.id || index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.projectName }}</td>
            <td>{{ item.messageName }}</td>
            <td>{{ item.messagePhone }}</td>
            <td>{{ item.messageAddress }}</td>
            <td v-if="item.mediaStatus === 1">{{ item.mediaName }}</td>
            <td>{{ formatTime(item.messageTime) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="table-pagination-bar">
<!--        <span class="table-count-bottom">
          共{{ total }}条数据 | 第{{ page }} / {{ totalPages }}页
        </span>
        <button class="page-arrow" :disabled="page <= 1" @click="goPrevPage">
          <i class="el-icon-arrow-left"></i>
        </button>
        <button class="page-arrow" :disabled="page >= totalPages" @click="goNextPage">
          <i class="el-icon-arrow-right"></i>
        </button>-->

        <el-pagination
            layout="total, pager, jumper"
            :total="total"
            :current-page="page"
            :page-size=10
            :pager-count="11"
            @current-change="handleCurrentChange"
            @prev-click="handlePrevClick"
            @next-click="handleNextClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'InfoMation',
  props: {
    msg: String
  },
  data() {
    return {
      tableData: [],
      projectList: [],
      selectedPhone: '',
      dateQuick: 'today',
      dateRange: [],
      page: 1,
      total: 0,
      totalPages: 1,
      isFiltered: false,
      exportLoading: false,
    }
  },
  async created() {
    // await this.fetchProjects();
    this.initDate();
    this.loadMessages();
  },
  methods: {
    async fetchProjects() {
      try {
        const res = await axios.get('/api/projects');
        this.projectList = res.data.data || [];
      } catch (e) {
        this.projectList = [];
      }
    },
    initDate() {
      const today = new Date();
      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const now = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;
      this.dateRange = [format(today), now(today)];
    },
    handleQuickDate(val) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let start, end;
      const format = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 00:00:00`;
      const endFormat = d => `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')} 23:59:59`;
      switch(val) {
        case 'today':
          start = format(today);
          end = endFormat(today);
          break;
        case 'yesterday':
          var yest = new Date(today);
          yest.setDate(yest.getDate() - 1);
          start = format(yest);
          end = endFormat(yest);
          break;
        case 'last7days':
          var last7 = new Date(today);
          last7.setDate(last7.getDate() - 6);
          start = format(last7);
          end = endFormat(today);
          break;
        case 'custom':
          // 不设置dateRange，允许自定义
          return;
      }
      this.dateRange = [start, end];
      // 不自动查询，需点按钮
    },
    onDateChange() {
      // 不自动查询，需点按钮
    },
    async loadMessages() {
      let customerId = '';
      const customerInfo = localStorage.getItem('customerInfo');
      if (customerInfo) {
        try {
          const info = JSON.parse(customerInfo);
          customerId = info.id || info.customerId || info.userId || '';
        } catch (e) {
          //
        }
      }
      if (!customerId && this.$route && this.$route.query && this.$route.query.customerId) {
        customerId = this.$route.query.customerId;
      }
      // 初始进入和默认查询，使用GET接口，带page参数
      const params = {
        phone: this.selectedPhone,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        page: this.page,
      };
      if (customerId) params.customerId = customerId;
      try {
        const res = await axios.get('/api/messages/customer/' + customerId, { params });
        // 适配新返回结构
        this.tableData = Array.isArray(res.data.data) ? res.data.data : [];
        this.total = res.data.total || 0;
        this.totalPages = res.data.totalPages || 1;
        console.log(this.tableData);
      } catch (e) {
        this.tableData = [];
        this.total = 0;
        this.totalPages = 1;
      }
    },
    async onFilterChange() {
      let customerId = '';
      const customerInfo = localStorage.getItem('customerInfo');
      if (customerInfo) {
        try {
          const info = JSON.parse(customerInfo);
          customerId = info.id || info.customerId || info.userId || '';
        } catch (e) {
          //
        }
      }
      if (!customerId && this.$route && this.$route.query && this.$route.query.customerId) {
        customerId = this.$route.query.customerId;
      }
      // 参数格式修正
      this.page = 1; // 查询时重置为第一页
      this.isFiltered = true; // 标记已用过查询
      const params = {
        customerId: Number(customerId),
        phone: this.selectedPhone || null,
        startDate: this.dateRange[0] ? this.dateRange[0].replace(' ', 'T') : null,
        endDate: this.dateRange[1] ? this.dateRange[1].replace(' ', 'T') : null,
        page: this.page,
      };
      // 移除为null的字段
      Object.keys(params).forEach(key => {
        if (params[key] === null) delete params[key];
      });
      try {
        const res = await axios.post('/api/messages/queryByCustomerProjectTime', params);
        this.tableData = Array.isArray(res.data.data) ? res.data.data : [];
        // 兼容后端返回分页数据
        this.total = res.data.total || this.tableData.length;
        this.totalPages = res.data.totalPages || 1;
        this.page = res.data.page || 1;
      } catch (e) {
        this.tableData = [];
        this.total = 0;
        this.totalPages = 1;
      }
    },
    async doExport() {
      let customerId = '';
      const customerInfo = localStorage.getItem('customerInfo');
      if (customerInfo) {
        try {
          const info = JSON.parse(customerInfo);
          customerId = info.id || info.customerId || info.userId || '';
        } catch (e) {
          console.log(e);
        }
      }
      if (!customerId && this.$route && this.$route.query && this.$route.query.customerId) {
        customerId = this.$route.query.customerId;
      }
      const params = {
        customerId: Number(customerId),
        phone: this.selectedPhone || "",
        startDate: this.dateRange[0] ? this.dateRange[0].replace(' ', 'T') : null,
        endDate: this.dateRange[1] ? this.dateRange[1].replace(' ', 'T') : null,
      };
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === undefined) delete params[key];
      });
      this.exportLoading = true;
      try {
        const res = await axios.get('/api/messages/getAllByCustomerProjectTime', { params });
        const list = Array.isArray(res.data.data) ? res.data.data : (res.data || []);
        if (!list.length) {
          this.$message && this.$message.info('暂无数据可导出') || alert('暂无数据可导出');
          return;
        }
        const hasMedia = list.some(item => item.mediaStatus === 1);
        const headers = hasMedia ? ['序号', '项目', '称呼', '电话/微信', '省/市', '媒体', '留言时间'] : ['序号', '项目', '称呼', '电话/微信', '省/市', '留言时间'];
        const rows = list.map((item, i) => {
          const row = [i + 1, item.projectName || '', item.messageName || '', item.messagePhone || '', item.messageAddress || ''];
          if (hasMedia) row.push(item.mediaStatus === 1 ? (item.mediaName || '') : '');
          row.push(this.formatTime(item.messageTime));
          return row;
        });
        const BOM = '\uFEFF';
        const csv = BOM + [headers.join(',')].concat(rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(','))).join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `留言信息_${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
        this.$message && this.$message.success('导出成功') || alert('导出成功');
      } catch (e) {
        this.$message && this.$message.error('导出失败') || alert('导出失败，请稍后重试');
      } finally {
        this.exportLoading = false;
      }
    },
    async goPrevPage() {
      if (this.page <= 1) return;
      this.page--;
      await this.reloadCurrentPage();
    },
    async goNextPage() {
      if (this.page >= this.totalPages) return;
      this.page++;
      await this.reloadCurrentPage();
    },
    async reloadCurrentPage() {
      let customerId = '';
      const customerInfo = localStorage.getItem('customerInfo');
      if (customerInfo) {
        try {
          const info = JSON.parse(customerInfo);
          customerId = info.id || info.customerId || info.userId || '';
        } catch (e) {
          //
        }
      }
      if (!customerId && this.$route && this.$route.query && this.$route.query.customerId) {
        customerId = this.$route.query.customerId;
      }
      if (this.isFiltered) {
        // 用户主动点过查询，分页用POST
        const params = {
          customerId: Number(customerId),
          phone: this.selectedPhone || null,
          startDate: this.dateRange[0] ? this.dateRange[0].replace(' ', 'T') : null,
          endDate: this.dateRange[1] ? this.dateRange[1].replace(' ', 'T') : null,
          page: this.page,
        };
        Object.keys(params).forEach(key => {
          if (params[key] === null) delete params[key];
        });
        try {
          const res = await axios.post('/api/messages/queryByCustomerProjectTime', params);
          this.tableData = Array.isArray(res.data.data) ? res.data.data : [];
          this.total = res.data.total || this.tableData.length;
          this.totalPages = res.data.totalPages || 1;
          this.page = res.data.page || this.page;
        } catch (e) {
          this.tableData = [];
          this.total = 0;
          this.totalPages = 1;
        }
      } else {
        // 初始/未点查询，分页用GET
        const params = {
          phone: this.selectedPhone,
          startDate: this.dateRange[0],
          endDate: this.dateRange[1],
          page: this.page,
        };
        if (customerId) params.customerId = customerId;
        try {
          const res = await axios.get('/api/messages/customer/' + customerId, { params });
          this.tableData = Array.isArray(res.data.data) ? res.data.data : [];
          this.total = res.data.total || 0;
          this.totalPages = res.data.totalPages || 1;
        } catch (e) {
          this.tableData = [];
          this.total = 0;
          this.totalPages = 1;
        }
      }
    },
    formatTime(time) {
      if (!time) return '';
      const d = new Date(time);
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      const h = d.getHours().toString().padStart(2, '0');
      const min = d.getMinutes().toString().padStart(2, '0');
      const s = d.getSeconds().toString().padStart(2, '0');
      return `${y}-${m}-${day} ${h}:${min}:${s}`;
    },
    // 页码变化
    async handleCurrentChange(newPage) {
      this.page = newPage;
      await this.reloadCurrentPage();
    },
    // 上一页点击
    async handlePrevClick(newPage) {
      this.page = newPage;
      await this.reloadCurrentPage();
    },
    // 下一页点击
    async handleNextClick(newPage) {
      this.page = newPage;
      await this.reloadCurrentPage();
    },
  },
  computed: {
    showMediaColumn() {
      // 如果 tableData 中有任意 mediaStatus === 1，就显示列
      return this.tableData.some(item => item.mediaStatus === 1);
    }
  }

}
</script>

<style scoped>
.main {
  padding: 0;
  width: 100%;
}
.header-actions-horizontal {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 22px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  color: #444;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s;
}

.action-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}

.action-btn.primary {
  background-color: #1890ff;
  color: white;
  border-color: #1890ff;
}

.action-btn.primary:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
  color: white;
}
.table-title-row-left {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}
.table-title-left {
  margin: 0;
  color: #333;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
}
.table-wrapper {
  position: relative;
  width: 100%;
  display: block;
}
.info-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.info-table th,
.info-table td {
  padding: 12px 15px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}
.info-table th {
  background-color: #42b983;
  color: white;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
.info-table tr:hover {
  background-color: #f5f5f5;
}
.info-table td {
  font-size: 14px;
}
.table-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;
  gap: 8px;
  width: 100%;
}
.table-count-bottom {
  color: #888;
  font-size: 15px;
  min-width: 180px;
  text-align: right;
}
.page-arrow {
  border: none;
  background: none;
  font-size: 18px;
  color: #42b983;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}
.page-arrow:disabled {
  color: #ccc;
  cursor: not-allowed;
  background: none;
}
.page-arrow:not(:disabled):hover {
  background: #e6f7f1;
}
</style>
